export default __webpack_public_path__ + "static/media/certificate-red.1a577950.svg";